/*
 * Copyright (c) 2021 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import React from "react";
import {AuthProvider} from "@forge/sso-client";
import {Loader} from "@scuf/common";
import { Switch, BrowserRouter } from "react-router-dom";
import {
    FCCallbackRoute,
    FCLoginRoute,
    FCLogoutRoute, FCPrivateDIYAppRoute,
} from "./FCAuthComponents";
import {FCPDIYGatewayManagementApp} from "../FCPDIYGatewayManagementApp";
import {DIYErrorPage} from "../common/DIYErrorPage";
import {
    IFCPDIYGatewayManagementProps
} from "../../stores/GatewayManager/IGatewayRegistrationInterfaces";

/**
 * Facade for FCP routes
 */
export const FCDIYAppRouteFacade = () => {
    /**
     * leverage the standard components for login, logout and callback defined by forge-sso library
     */
    return (
        <AuthProvider loadingComponent={Loader}>
            <BrowserRouter>
                <Switch>
                    <FCCallbackRoute path="/fcp/register/callback" />
                    <FCLoginRoute path="/fcp/register/login" />
                    <FCLogoutRoute path="/fcp/register/logout" />
                    <FCPrivateDIYAppRoute path="/fcp/register/main">
                        {
                            ({
                                 userInfo,
                                 logout
                             }: IFCPDIYGatewayManagementProps) => {
                                return (!!userInfo) ?
                                    <FCPDIYGatewayManagementApp userInfo={userInfo}
                                                          logout={logout}/> :
                                    <div className='root'>
                                        <div className='application-container'>
                                            <div className='application-main-content'>
                                                <DIYErrorPage errorTitle='Unable to authenticate...'
                                                              message={`User details not found, Please refresh the page.`}
                                                              showSupportLink={false}/>
                                            </div>
                                        </div>
                                    </div>
                            }
                        }
                    </FCPrivateDIYAppRoute>
                </Switch>
            </BrowserRouter>
        </AuthProvider>
    );
}